import React, { useMemo, useState } from 'react'
import { Column } from 'primereact/column'
import { LookupField } from '../lookup/LookupField'
import { filtrarPerfis, filtrarPerfisPorColuna, paginaLocal } from './filtrosSalvos.utils'

const LINHAS = 10

/**
 * Lookup de perfil do filtro salvo (PHOENIX-107): o mesmo LookupField da tela de Permissao, selecao unica, mas so com
 * os perfis do usuario logado (vindos do back de uma vez), filtrados e paginados aqui.
 *
 * Props:
 * - perfis: [{ id, value }]
 * - value: { id, value } escolhido, ou null
 * - onChange(perfil | null)
 * - label, header, textos: { codigo, nome }
 */
export const LookupPerfilConjunto = ({ perfis, value, onChange, label, header, textos }) => {
  const [texto, setTexto] = useState(null)
  const [sugestoes, setSugestoes] = useState([])
  const [visivel, setVisivel] = useState(false)
  const [filtro, setFiltro] = useState({})
  const [first, setFirst] = useState(0)
  const [rows, setRows] = useState(LINHAS)

  // a tabela do lookup e o autocompletar trabalham com { oid, nomePerfil }, como o lookup da Permissao
  const comoLinha = (perfil) => ({ oid: perfil.id, nomePerfil: perfil.value })
  const filtrados = useMemo(() => filtrarPerfisPorColuna(perfis, filtro).map(comoLinha), [perfis, filtro])

  const escolher = (linha) => {
    setTexto(null)
    onChange(linha ? { id: linha.oid, value: linha.nomePerfil } : null)
  }

  const fechar = () => {
    setVisivel(false)
    setFiltro({})
    setFirst(0)
  }

  const colunas = [
    <Column key="oid" field="oid" header={textos.codigo} filter={true} style={{ width: '8em' }} />,
    <Column key="nomePerfil" field="nomePerfil" header={textos.nome} filter={true} />,
  ]

  return (
    <LookupField
      label={label}
      header={header}
      value={texto !== null ? texto : value ? value.value : ''}
      name="nomePerfil"
      field="nomePerfil"
      onComplete={(e) => setSugestoes(filtrarPerfis(perfis, e.query).map(comoLinha))}
      onInputFilter={(e) => {
        // digitando: so texto, sem perfil escolhido; escolhendo uma sugestao: o perfil
        if (typeof e.value === 'string') {
          setTexto(e.value)
          onChange(null)
        } else {
          escolher(e.value)
        }
      }}
      editHidden={true}
      onClick={() => setVisivel(true)}
      visible={visivel}
      modal={true}
      appendTo={document.body}
      onHide={fechar}
      onCancel={fechar}
      onConfirm={(e) => {
        escolher(e.selection)
        fechar()
      }}
      records={visivel ? paginaLocal(filtrados, first, rows) : sugestoes}
      columns={colunas}
      totalRecords={filtrados.length}
      first={first}
      rows={rows}
      onPage={(e) => {
        setFirst(e.first)
        setRows(e.rows)
      }}
      onFilter={(e) => {
        const filtros = e.filters || {}
        const valorDe = (campo) => (filtros[campo] && filtros[campo].value) || ''
        setFiltro({ nome: valorDe('nomePerfil'), codigo: valorDe('oid') })
        setFirst(0)
      }}
    />
  )
}
